import React, { useState } from "react"
import { Container, Collapse, Navbar, NavbarToggler, Row } from "reactstrap"
import Link from "./link"
import Navigation from "reactstrap-json-nav"
import navigation from "../data/navigation"
import styled from "styled-components"
import twologo from "../assets/images/2qa_logo.png"

let StyledNavbar = styled((props) => <Navbar {...props} />)`
  position: sticky;
  top: 0;
  margin-bottom: -1rem;
  z-index: 10;
  // background: linear-gradient( 90deg,  rgba(255,129,79,1) 11.2%, rgba(231,62,68,1) 53.6%, #A00429 91.1% );
  background: linear-gradient( 90deg,  #000000 11.2%, rgb(124,34,26) 53.6%, #93131a 91.1% );
`

const Header = (props) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggle = () => setIsOpen(!isOpen)

  return (
    <StyledNavbar color="light" dark expand="md">
      <Container>
        <Link to="/" className="navbar-brand">
          <Row>
            <img src={twologo} alt="2Q Logo" className="mx-3" style={{maxWidth: '15%'}} />
            <p className="mt-3 d-none d-sm-block" style={{fontSize: '1.1rem', fontWeight: '700', fontFamily:'Poppins'}}>Two Q Alliance Sdn. Bhd.</p>
            <p className="mt-3 d-md-none" style={{fontSize: '0.6rem', fontWeight: '700', fontFamily:'Poppins'}}>Two Q Alliance Sdn. Bhd.</p>
          </Row>
          
        </Link>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Navigation
            json={navigation}
            link={Link}
            activeClassName="active"
          />
        </Collapse>
      </Container>
    </StyledNavbar>
  )
}

export default Header
